import useSWRMutation from "swr/mutation";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { ServicesURL } from "@utils/utilsApi";

interface UsePromoteDraftArgs {
  corporateId: string;
}

const suppressGlobalErrorModal = () => undefined;

export const usePromoteDraft = ({ corporateId }: UsePromoteDraftArgs) => {
  const { trigger, isMutating } = useSWRMutation(
    ServicesURL.v2DraftPromote,
    async (_key: string, { arg }: { arg: { draftId: number } }) => {
      const url = ServicesURL.v2DraftPromote
        .replace(":idCorporate", corporateId)
        .replace(":id", String(arg.draftId));
      return fetcher(url, MethodType.POST);
    },
    { onError: suppressGlobalErrorModal },
  );

  return {
    promoteDraft: (draftId: number) => trigger({ draftId }),
    isPromoting: isMutating,
  };
};
